import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";

// Helper: parse values (handle repeated keys as arrays)
const getParamsObject = (searchParams: URLSearchParams): Record<string, string | string[]> => {
  const obj: Record<string, string | string[]> = {};

  for (const key of searchParams.keys()) {
    const values = searchParams.getAll(key);
    obj[key] = values;
  }

  return obj;
};

export function useFilters() {
  const [searchParams, setSearchParams] = useSearchParams();

  // 2. Internal state synced with query params
  const [filters, setFilters] = useState(() => getParamsObject(searchParams));

  // 3. Update state when URL changes
  useEffect(() => {
    setFilters(getParamsObject(searchParams));
  }, [searchParams]);

  // 4. Update URL when state changes
  useEffect(() => {
    const newParams = new URLSearchParams();

    Object.entries(filters).forEach(([key, value]) => {
      if (Array.isArray(value)) {
        value.forEach((v) => {
          if (v !== "" && v != null) newParams.append(key, v);
        });
      } else if (value !== "" && value != null) {
        newParams.set(key, value);
      }
    });

    setSearchParams(newParams);
  }, [JSON.stringify(filters)]);

  const queryString = searchParams.toString();
  return { filters, setFilters, queryString };
}
